import { Component, effect, inject, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FieldTree, FormField } from '@angular/forms/signals';
import { FormsModule } from '@angular/forms';
import { AddressSchemaService, fieldMap } from '@app/services/address-schema.service';
import { Address } from '@app/models/addresses/address.interface';
import { DropdownAddressFieldInfo } from '@app/models/addresses/formatting/dropdown-address-field-info.class';
import { TextAddressFieldInfo } from '@app/models/addresses/formatting/text-address-field-info.class';

@Component({
    selector: 'app-address-input',
    imports: [TranslateModule, FormField, FormsModule],
    templateUrl: './address-input.component.html',
    styleUrl: './address-input.component.scss'
})
export class AddressInputComponent {
    protected readonly TextAddressFieldInfo = TextAddressFieldInfo;
    protected readonly DropdownAddressFieldInfo = DropdownAddressFieldInfo;
    readonly schemaService = inject(AddressSchemaService);
    readonly addressInput = input.required<FieldTree<Address>>();
    readonly addressFormat = this.schemaService.addressFormat;
    readonly isAddressFormatLoading = this.schemaService.isLoading;
    readonly country = this.schemaService.country;

    readonly _updateAddressSchema = effect(() => {
        this.schemaService.country.set(this.addressInput().countryCode().value() ?? '');
    });

    readonly _updateFormCountry = effect(() => {
        this.addressInput().countryCode().value.set(this.country() ?? '');
    });

    readonly _resetFormValues = effect(() => {
        for (const key of fieldMap.values()) {
            if (!this.schemaService.fields() || this.schemaService.fields().length === 0) {
                return;
            }
            if (key !== 'countryCode' && !this.schemaService.fields().some(f => f.id === key)) {
                this.addressInput()[key]().value.set('');
            }
        }
    });
}
